// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1t4XO","buttons":"styles_buttons__1vME4"};